import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";
import EmergencyProcedureUseWhenSection from "./EmergencyProcedureUseWhenSection";
import EmergencyProcedureDoNotUseWhenSection from "./EmergencyProcedureDoNotUseWhenSection";
import EmergencyProcedureRichTextSection from "./EmergencyProcedureRichTextSection";
import EmergencyPlanResponseProcedureSection from "../../JobShiftEmergencyDocuments/sections/EmergencyPlanResponseProcedureSection";
import EmergencyProcedureRescueConfigurationMediaSection from "./EmergencyProcedureRescueConfigurationMediaSection";
import EmergencyProcedureCustomSection from "./EmergencyProcedureCustomSection";

export const getEnabledProcedureSections = (procedure = {}) => {
  const sections = Array.isArray(procedure.sections) ? procedure.sections : [];
  const sectionById = sections.reduce((result, section) => {
    if (section && section.id) result[section.id] = section;
    return result;
  }, {});

  return (Array.isArray(procedure.section_order) ? procedure.section_order : [])
    .map((sectionId) => sectionById[sectionId])
    .filter((section) => (
      section
      && section.type !== "procedure_application"
      && section.data
      && section.data.toggle === 1
    ));
};

export const getProcedureSectionAnchor = (procedureKey, sectionId) => `emergency-procedure-${procedureKey}-${sectionId}`;

export default function ProcedureDynamicSections({ procedure, swmsSections = {}, sectionNumberStart = 3, withNavigationAnchors = false, procedureKey = "" }) {
  return getEnabledProcedureSections(procedure).map((section, index) => {
    const content = section.type === "use_when" ? (
      <EmergencyProcedureUseWhenSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} />
    ) : section.type === "do_not_use_when" ? (
      <EmergencyProcedureDoNotUseWhenSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} />
    ) : section.type === "stop_escalate" ? (
      <EmergencyProcedureRichTextSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} fallbackName="Stop / Escalate" />
    ) : section.type === "after_recovery" ? (
      <EmergencyProcedureRichTextSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} fallbackName="After Recovery" />
    ) : section.type === "perform_rescue" ? (
      <EmergencyPlanResponseProcedureSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} procedureMode />
    ) : section.type === "rescue_configuration_media" ? (
      <EmergencyProcedureRescueConfigurationMediaSection key={section.id} section={section} sections={swmsSections} sectionNumber={sectionNumberStart + index} />
    ) : section.type === "custom" ? (
      <EmergencyProcedureCustomSection key={section.id} section={section} sectionNumber={sectionNumberStart + index} />
    ) : (
      <div className={styles.PreviewSectionBlock} key={section.id}>
        <div className={styles.PreviewSectionHead}>
          <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.EmergencyProcedureSectionNum}`}>
            {sectionNumberStart + index}
          </span>
          {section.display_name || section.type || section.id}
        </div>
        <div className={styles.PreviewSectionBody}>
          <div className={styles.PreviewPadding}><p /></div>
        </div>
      </div>
    );

    return withNavigationAnchors ? (
        <div key={section.id} id={getProcedureSectionAnchor(procedureKey, section.id)} style={{ scrollMarginTop: "140px" }}>
          {content}
        </div>
    ) : content;
  });
}
